import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';
import { ExpensesContainer } from './expensesContainer';

export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => DialogTitle,
  }, overrideReadOnly)
  .typeOverride('collection', {
    _component: () => ExpensesContainer,
  }, overrideReadOnly);
